import { useEffect, useState } from "react";
import { CardTaps } from "../../../theme/Component/CardTaps"
import { ContractTypeEditor } from "./ComponentsContract/EditorsEmployeContrac/ContractType.editor";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _EmployeeContract } from "../../../../core/services/dataBean/EntityCatalog";
import { EmployeeContractTypeEditor } from "./ComponentsContract/EditorsEmployeContrac/EmployeeContractType.editor";
import { InputDate } from "../../../theme/Input/InputDate";
import { ConstractStateEditor } from "./ComponentsContract/EditorsEmployeContrac/ConstractState.editor";
import { RevenueTypeEditor } from "./ComponentsContract/EditorsEmployeContrac/RevenueType.editor";
import { PayrollTypeSelect } from "../../ParametrosTalentoHumano/PayrollFactor/PayrollTypeSelect";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { EmploymentTypeEditor } from "./ComponentsContract/EditorsEmployeContrac/EmploymentType.editor";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";
import { CostingCenterSelect } from "../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { WelfareEntitySelector } from "./ComponentsContract/EditorsEmployeContrac/WelfareEntitySelector";
import { ContributorTypeEditor } from "./ComponentsContract/EditorsEmployeContrac/ContributorType.editor";
import { ContributorSubTypeEditor } from "./ComponentsContract/EditorsEmployeContrac/ContributorSubType.editor";
import { ARPRiskEditor } from "./ComponentsContract/EditorsEmployeContrac/ARPRisk.editor";
import { EditorTaxProcedureList } from "./ComponentsContract/EditorTaxProcedureList/EditorTaxProcedureList";

interface Props{
    bean:any;
    setBean:any;
}
export const EditEmployeeContract = ({bean,setBean}:Props) => {

    const employeeContract = useDataBean(_EmployeeContract);
    // const {bean,setBean,lista,setLista} = employeeContract;

        const taps = [
            { id: 0, name: 'Información Contrato' },
            { id: 1, name: 'Información interna' },
            { id: 2, name: 'Seguridad Social y Aportes' },
            { id: 3, name: 'Retención en la Fuente' },
            { id: 4, name: 'Liquidación Final de Contrato' },
        ];
    
        const [indexTap, setIndexTap] = useState(0);


    return (
        <div className="row">
            <div className="col-md-12">
                <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                    {indexTap == 0 &&
                        <div className="row">
                            <div className="col-md-6">
                                <ContractTypeEditor idSelector={bean.ContractType} onChange={(e) => { setBean({ ...bean, "ContractType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <EmployeeContractTypeEditor idSelector={bean.IDEmployeeContractType} onChange={(e) => { setBean({ ...bean, "IDEmployeeContractType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Tiempo de Prueba</label>
                                <input type="text" className="form-control" name="JobTestTime" value={bean.JobTestTime} onChange={(e) => { setBean({ ...bean, "JobTestTime": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Perídos Pendientes de Vacaciones</label>
                                <input type="text" className="form-control" name="VacPendingPeriods" value={bean.VacPendingPeriods} onChange={(e) => { setBean({ ...bean, "VacPendingPeriods": e.target.value }) }} />
                            </div>
                            {/* <div className="col-md-6">
                                                    <EmployeeLiquidateEditor idSelector={bean.IDEmployeeLiquidate} onChange={(e) => { setBean({ ...bean, "IDEmployeeLiquidate": e }) }} />
                                                </div> */}
                            <div className="col-md-6">
                                <label>Fecha de Inicio en Nación/Grupo Empresarial</label>
                                <InputDate name="NationInit" value={bean.NationInit} setDate={(e) => { setBean({ ...bean, "NationInit": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <ConstractStateEditor idSelector={bean.ContractState} onChange={(e) => { setBean({ ...bean, "ContractState": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fecha de Inicio de Contrato</label>
                                <InputDate name="InitContract" value={bean.InitContract} setDate={(e) => { setBean({ ...bean, "InitContract": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <RevenueTypeEditor label="Tipo de Salario" idSelector={bean.RevenueType} onChange={(e) => { setBean({ ...bean, "RevenueType": e }) }} />
                            </div>


                            <div className="col-md-6">
                                <PayrollTypeSelect idSelector={bean.IDPayrollType} onChange={(e) => { setBean({ ...bean, "IDPayrollType": e }) }} />
                            </div>
                            <div className="col-md-6 d-flex-wrap align-content-center">
                                <BasicSwitch estado={bean.UseContractSalaryValue} eventChange={(e) => { setBean({ ...bean, "UseContractSalaryValue": e }) }} label="Usar Salario Definido en el Contrato" />
                            </div>
                            {bean.UseContractSalaryValue &&
                                <div className="col-md-6">
                                    <InputMoney _label="Salario Definido por Contrato" _value={bean.ContractSalaryValue} onChange={(e) => { setBean({ ...bean, "ContractSalaryValue": e }) }} />
                                </div>
                            }
                            <div className="col-md-12 d-flex-wrap align-content-center">
                                <BasicSwitch estado={bean.modifyDate ?? false} eventChange={(e) => { setBean({ ...bean, "modifyDate": e }) }} label="Modificar Fechas" />
                                <small>Activa esta opción si deseas modificar las fechas del contrato</small>
                            </div>
                            <div className="col-md-6">
                                <label>Fecha de Renuncia</label>
                                <InputDate _disable={!bean.modifyDate} name="EndingDate" value={bean.EndingDate} setDate={(e) => { console.log(e); setBean({ ...bean, "EndingDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fecha de Liquidación de Contrato </label>
                                <InputDate _disable={!bean.modifyDate} name="UptoContract" value={bean.UptoContract} setDate={(e) => { setBean({ ...bean, "UptoContract": e }) }} />
                            </div>


                        </div>
                    }
                    {indexTap == 1 &&
                        <div className="row">
                            <div className="col-md-6">
                                <label >Actividad Economicá (CIIU)</label>
                                <input type="number" className="form-control" value={bean.CIIUCode} onChange={(e) => { setBean({ ...bean, "CIIUCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <EmploymentTypeEditor idSelector={bean.IDEmploymentType} onChange={(e) => { setBean({ ...bean, "IDEmploymentType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectSiteID label="Ciudad de Ejecución de Labores" edit idLnSite={bean.IDLnSiteID} onChange={(e) => { setBean({ ...bean, "IDLnSiteID": e.IDLn }) }} />
                            </div>
                            <div className="col-md-6 d-flex-wrap align-content-center">
                                <BasicSwitch label=" Definir CDPs para este contrato" estado={bean.UseCreatedCDP} eventChange={(e) => { setBean({ ...bean, "UseCreatedCDP": e }) }} />
                            </div>
                            <div className="col-md-6 d-flex-wrap align-content-center">
                                <BasicSwitch label="Definir Centro de Costo" estado={bean.UseOwnCostingCenter} eventChange={(e) => { setBean({ ...bean, "UseOwnCostingCenter": e }) }} />
                            </div>
                            {bean.UseOwnCostingCenter &&
                                <div className="col-md-6">
                                    <CostingCenterSelect fKey="Code" idSelector={bean.CostingCenter} label="Centro de Costo" onChange={(e) => { setBean({ ...bean, "CostingCenter": e }) }} />
                                </div>
                            }
                        </div>
                    }
                    {indexTap == 2 &&
                        <div className="row">
                            <div className="col-md-6">
                                <WelfareEntitySelector entity={0} idSelector={bean.EPS} onChange={(e) => { setBean({ ...bean, "EPS": e === null ? -1 : e }) }} label="Entidad Promotora de Salud" />
                            </div>
                            <div className="col-md-6">
                                <WelfareEntitySelector entity={1} idSelector={bean.ARP} onChange={(e) => { setBean({ ...bean, "ARP": e === null ? -1 : e }) }} label="Aseguradora de Riesgos Profesionales" />
                            </div>
                            <div className="col-md-6">
                                <WelfareEntitySelector entity={2} idSelector={bean.CCF} onChange={(e) => { setBean({ ...bean, "CCF": e === null ? -1 : e }) }} label="Caja de Compensación Familiar" />
                            </div>
                            <div className="col-md-6">
                                <WelfareEntitySelector entity={3} idSelector={bean.FP} onChange={(e) => { setBean({ ...bean, "FP": e === null ? -1 : e }) }} label="Fondo de Pensiones" />
                            </div>
                            <div className="col-md-6">
                                <WelfareEntitySelector entity={9} idSelector={bean.FCE} onChange={(e) => { setBean({ ...bean, "FCE": e === null ? -1 : e }) }} label="Fondo de Cesantias" />
                            </div>

                            <div className="col-md-6" />
                            <div className="col-md-6">
                                <ContributorTypeEditor idSelector={bean.EmployeeType} onChange={(e) => { setBean({ ...bean, "EmployeeType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <ContributorSubTypeEditor idSelector={bean.EmployeeSubtype} onChange={(e) => { setBean({ ...bean, "EmployeeSubtype": e === null ? -1 : e }) }} />
                            </div>
                            <div className="col-md-6">
                                <ARPRiskEditor idSelector={bean.ARPRisk} onChange={(e) => { setBean({ ...bean, "ARPRisk": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Subtipo de Riesgo Laboral</label>
                                <input type="number" className="form-control" value={bean.ARPRiskSubtype} onChange={(e) => { setBean({ ...bean, "ARPRiskSubtype": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fecha de Ultimo Exámen Medico/Ocupacional</label>
                                <InputDate name="HealthTestDate" value={bean.HealthTestDate} setDate={(e) => { setBean({ ...bean, "HealthTestDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fecha de Ultimas Vacaciones</label>
                                <InputDate name="LastVacDate" value={bean.LastVacDate} setDate={(e) => { setBean({ ...bean, "LastVacDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fecha de Ultima Dotación</label>
                                <InputDate name="LastEndowmentDate" value={bean.LastEndowmentDate} setDate={(e) => { setBean({ ...bean, "LastEndowmentDate": e }) }} />
                            </div>

                        </div>
                    }{indexTap == 3 &&
                        <>
                            <div className="row">
                                <div className="col-md-6">

                                    <EditorTaxProcedureList label="Método de Cálculo" idSelector={bean.IDTaxRetentionMethod} onChange={(e) => { setBean({ ...bean, "IDTaxRetentionMethod": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>% Fijo de Retención para el Procedimiento 2</label>
                                    <input type="number" className="form-control" value={bean.TaxRetentionPercent2} onChange={(e) => { setBean({ ...bean, "TaxRetentionPercent2": e.target.value }) }} />
                                </div>

                                <div className="col-md-6 d-flex-wrap align-content-center">
                                    <BasicSwitch label="Definir UVTs máximas para Retefuente" estado={bean.UseUVTMaxRetefuente} eventChange={(e) => { setBean({ ...bean, "UseUVTMaxRetefuente": e }) }} />
                                </div>
                                {bean.UseUVTMaxRetefuente &&
                                    <div className="col-md-6">
                                        <label>UVTs Máximas de Descuentos</label>
                                        <input className="form-control" type="number" value={bean.UVTMaxRetefuente} onChange={(e) => { setBean({ ...bean, "UVTMaxRetefuente": e.target.value }) }} />
                                    </div>
                                }

                            </div>

                        </>
                    }
                    {indexTap == 4 &&
                        <>
                            <div className="row">
                                <div className="col-md-6 d-flex-wrap align-content-center">
                                    <BasicSwitch label="Definir Días de Reconocimiento Final de Vacaciones" estado={bean.UseEndupVacationRecognitionDays} eventChange={(e) => { setBean({ ...bean, "UseEndupVacationRecognitionDays": e }) }} />
                                </div>
                                {bean.UseEndupVacationRecognitionDays && <>
                                    <div className="col-md-6">
                                        <label>Días de Reconocimiento Final de Vacaciones</label>
                                        <input className="form-control" type="text" value={bean.EndupVacationRecognitionDays} onChange={(e) => { setBean({ ...bean, "EndupVacationRecognitionDays": e.target.value }) }} />
                                    </div>
                                </>}
                                <div className="col-md-6 d-flex-wrap align-content-center">
                                    <BasicSwitch label="Definir Valor de la Retención en la Fuente" estado={bean.UseEndupWithHoldingTax} eventChange={(e) => { setBean({ ...bean, "UseEndupWithHoldingTax": e }) }} />
                                </div>
                                {bean.UseEndupWithHoldingTax && <>
                                    <div className="col-md-6">
                                        <label>Valor de la Retención en la Fuente</label>
                                        <input className="form-control" type="text" value={bean.EndupWithHoldingTax} onChange={(e) => { setBean({ ...bean, "EndupWithHoldingTax": e.target.value }) }} />
                                    </div>
                                </>}
                            </div>
                        </>
                    }
                </CardTaps>
            </div>
        </div>
    )
}